import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// A click on "Yes, cancel task" this soon after the prompt opened is the tail
// of the click that opened it (a double-click), not a decision.
export const CONFIRM_GUARD_MS = 400;

/**
 * Inline "Cancel this task?" prompt shared by the unit Activity tab and the
 * Task Board.
 *
 * "Keep task" comes first and takes focus, so a double-click or a repeated
 * Enter / Space on "Cancel task" lands on the safe choice. "Yes, cancel task"
 * also ignores the second click of a double-click and any click within
 * CONFIRM_GUARD_MS of the prompt opening.
 */
function CancelTaskConfirm({ onConfirm, onKeep, classPrefix, buttonClass, dangerClass }) {
    const keepRef = useRef(null);
    const openedAt = useRef(Date.now());

    useEffect(() => {
        openedAt.current = Date.now();
        keepRef.current?.focus();
    }, []);

    const handleConfirm = (e) => {
        if (e.detail > 1 || Date.now() - openedAt.current < CONFIRM_GUARD_MS) return;
        onConfirm();
    };

    return (
        <div className={`${classPrefix}-cancel-confirm`} role="group" aria-label="Confirm cancelling this task">
            <span className={`${classPrefix}-cancel-confirm-text`}>Cancel this task?</span>
            <button type="button" ref={keepRef} className={buttonClass} onClick={onKeep}>
                Keep task
            </button>
            <button type="button" className={`${buttonClass} ${dangerClass}`} onClick={handleConfirm}>
                Yes, cancel task
            </button>
        </div>
    );
}

CancelTaskConfirm.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onKeep: PropTypes.func.isRequired,
    classPrefix: PropTypes.string.isRequired,
    buttonClass: PropTypes.string.isRequired,
    dangerClass: PropTypes.string.isRequired,
};

export default CancelTaskConfirm;
